import React, { useMemo, useRef } from 'react';

import { debounce } from 'lodash';
import { useCodingProblemProps } from '../context';
import { useStableCallback } from '../../../utils/hooks';
import { PythonBlocklyAnswer } from '../__blockly/coding-problem__blockly';
import { useCodingStore } from '../state';
import { CodingProblemBlocklyLoadable } from '../__blockly/coding-problem__blockly-loadable';
import { CodingVerdict } from '../__verdict/coding-problem__verdict';

export function CodingBlocklyEditor() {
    const props = useCodingProblemProps();
    const language = props.problem.markup.languages[0];
    const initialCode = props.showCorrectAnswers
        ? language.author_solution_blockly
        : props.attempt?.markers?.user_answer?.blockly_code || language.initial_code_blockly;
    const readOnly = props.readOnly === true;
    const setAnswer = useStableCallback(({ code, blocks }: PythonBlocklyAnswer) => {
        props.setAnswer?.({
            markerAnswer: {
                user_answer: {
                    code,
                    blockly_code: blocks,
                    language: language.language,
                },
            },
        });
    });
    const setAnswerDebounced = useMemo(() => debounce(setAnswer, 200), [setAnswer]);
    const skipInitialSetAnswer = useRef(true);
    const setCode = useCodingStore((store) => store.setCode);
    const key = `${readOnly ? 'readOnly' : 'answer'}-${props.showCorrectAnswers ? 'correctAnswer' : ''}`;
    return (
        <>
            <CodingProblemBlocklyLoadable
                availableBlocks={language.available_blocks}
                defaultValue={initialCode}
                key={key}
                onChange={
                    readOnly
                        ? undefined
                        : ({ code, blocks }) => {
                              setCode(code);
                              if (skipInitialSetAnswer.current) {
                                  skipInitialSetAnswer.current = false;
                                  return;
                              }
                              setAnswerDebounced({ code, blocks });
                          }
                }
                preCode={language.pre_user_code}
                readOnly={readOnly}
            />
            <CodingVerdict />
        </>
    );
}
